// as per BFF https://github.com/xero-internal/ecosystem-outbound-bff/blob/main/src/Connect.Web/Constants/Country.cs
// for the purposes of our Shopify integration, only NZ, UK and AU are considered commonwealth
export const isCommonwealthRegion = (region: string) => {
    return region === 'NZ' || region === 'AU' || region === 'UK' || region === 'GB';
};
